module.exports = __webpack_public_path__ + "static/img/title_fr.359388c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/img/title_fr.png
// module id = RnfK
// module chunks = 0